(function () {
    const form = document.getElementById("chapter-interest-form");
    if (!form) return;


    const submitButton = document.getElementById("submit-button");
    const formView = document.getElementById("form-view");
    const confirmationView = document.getElementById("confirmation-view");
    const serviceError = document.getElementById("service-error");
    const contributionGroup = document.getElementById("contribution-group");
    const submitButtonDefaultText = submitButton.textContent;
    const submitButtonSubmittingText = submitButton.dataset.submittingLabel || submitButtonDefaultText;

    function getErrorElement(fieldId) {
        return document.getElementById(`${fieldId}-error`);
    }

    function showFieldError(fieldId, message) {
        const field = document.getElementById(fieldId);
        const error = getErrorElement(fieldId);

        if (field) {
            field.setAttribute("aria-invalid", "true");
            field.classList.add("error");
        }

        if (error) {
            if (message) {
                error.textContent = message;
            }
            error.classList.remove("d-none");
        }
    }

    function clearFieldError(fieldId) {
        const field = document.getElementById(fieldId);
        const error = getErrorElement(fieldId);

        if (field) {
            field.removeAttribute("aria-invalid");
            field.classList.remove("error");
        }

        if (error) {
            error.classList.add("d-none");
        }
    }

    function setContributionError(hasError) {
        contributionGroup.querySelectorAll(".checkbox-item").forEach((item) => {
            item.classList.toggle("error", hasError);
        });
        getErrorElement("contribution").classList.toggle("d-none", !hasError);
    }

    function clearAllErrors() {
        [
            "first-name",
            "last-name",
            "email",
            "linkedin",
            "country-region"
        ].forEach(clearFieldError);

        setContributionError(false);
        serviceError.classList.add("d-none");
    }

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function isValidUrl(value) {
        try {
            const url = new URL(value);
            return url.protocol === "http:" || url.protocol === "https:";
        } catch {
            return false;
        }
    }

    function validateForm() {
        clearAllErrors();

        let isValid = true;
        let firstInvalidControl = null;

        const firstName = document.getElementById("first-name");
        const lastName = document.getElementById("last-name");
        const email = document.getElementById("email");
        const linkedin = document.getElementById("linkedin");
        const countryRegion = document.getElementById("country-region");
        const selectedContributions = Array.from(
            document.querySelectorAll('input[name="contribution[]"]:checked')
        );

        const flagInvalid = (control, action) => {
            isValid = false;
            action();
            if (!firstInvalidControl) {
                firstInvalidControl = control;
            }
        };

        if (!firstName.value.trim()) {
            flagInvalid(firstName, () => showFieldError("first-name"));
        }

        if (!lastName.value.trim()) {
            flagInvalid(lastName, () => showFieldError("last-name"));
        }

        if (!email.value.trim() || !isValidEmail(email.value.trim())) {
            flagInvalid(email, () => showFieldError("email"));
        }

        if (!linkedin.value.trim() || !isValidUrl(linkedin.value.trim())) {
            flagInvalid(linkedin, () => showFieldError("linkedin"));
        }

        if (!countryRegion.value.trim()) {
            flagInvalid(countryRegion, () => showFieldError("country-region"));
        }

        if (selectedContributions.length === 0) {
            // The group is a plain div and cannot take focus; its first checkbox can,
            // which is what scrolls the marked group into view.
            flagInvalid(contributionGroup.querySelector('input[type="checkbox"]'), () => setContributionError(true));
        }

        if (!isValid) {
            firstInvalidControl?.focus?.();
        }

        return isValid;
    }

    function showConfirmation() {
        formView.hidden = true;
        confirmationView.classList.remove("d-none");
        confirmationView.focus?.();
        document.getElementById("form-card").scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "center"
        });
    }

    function showServiceError() {
        serviceError.classList.remove("d-none");
        serviceError.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    async function handleSubmit() {
        submitButton.disabled = true;
        submitButton.textContent = submitButtonSubmittingText;
        serviceError.classList.add("d-none");

        try {
            const response = await fetch(form.getAttribute("action"), {
                method: "POST",
                headers: { "Accept": "application/json" },
                body: new FormData(form)
            });

            if (!response.ok) {
                throw new Error("Submission failed");
            }

            showConfirmation();
        } catch (error) {
            console.error("Chapter interest submission failed:", error);
            showServiceError();
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = submitButtonDefaultText;
        }
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return;
        }

        await handleSubmit();
    });


    document.getElementById("first-name").addEventListener("input", (event) => {
        if (event.target.value.trim()) clearFieldError("first-name");
    });

    document.getElementById("last-name").addEventListener("input", (event) => {
        if (event.target.value.trim()) clearFieldError("last-name");
    });

    document.getElementById("email").addEventListener("input", (event) => {
        if (isValidEmail(event.target.value.trim())) clearFieldError("email");
    });

    document.getElementById("linkedin").addEventListener("input", (event) => {
        if (isValidUrl(event.target.value.trim())) clearFieldError("linkedin");
    });

    document.getElementById("country-region").addEventListener("input", (event) => {
        if (event.target.value.trim()) clearFieldError("country-region");
    });

    document.querySelectorAll('input[name="contribution[]"]').forEach((input) => {
        input.addEventListener("change", () => {
            if (document.querySelector('input[name="contribution[]"]:checked')) {
                setContributionError(false);
            }
        });
    });
})();
